export const getConstructor = function (value) {
  var string = Object.prototype.toString.call(value);
  var ref = /\[object (.*?)\]/.exec(string);
  var constructor = ref[1];
  return constructor
}

export const is = (value, constructor) => {
  var isEquals = constructor === getConstructor(value);
  return isEquals
}



// WEBPACK FOOTER //
// ./src/helpers/validate/is.js